// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"daccdf92","453":"b36d1617"}[chunkId] + ".chunk.js";
};